import { Box, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const IconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color, theme }) => ({
  display: "flex",
  padding: theme.spacing(2),
  color: color ? color : "auto",
}));

export const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color, theme }) => ({
  display: "flex",
  padding: theme.spacing(2),
  color: color ? color : "auto",
  alignItems: "center",
}));

export const SpacedPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "spaced",
})(({ spaced, theme }) => ({
  borderRadius: 0,
  margin: spaced ? `${theme.spacing(2)} 0` : "auto",
}));
